if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.allowClose = false;
      }
      hide() {
        if (this.allowClose) {
          super.hide();
        }
      }
      manualClose() {
        this.allowClose = true;
        super.hide();
        this.allowClose = false;
      }
      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }
      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((el) => el.classList.remove('active'));
        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
        );
        if (!activeMedia) return;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView({ block: 'nearest' });
      }
    }
  );
}